import { render, staticRenderFns } from "./PsychologistData.vue?vue&type=template&id=2874c0f4&scoped=true"
import script from "./PsychologistData.vue?vue&type=script&lang=js"
export * from "./PsychologistData.vue?vue&type=script&lang=js"
import style0 from "./PsychologistData.vue?vue&type=style&index=0&id=2874c0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874c0f4",
  null
  
)

export default component.exports